import React from 'react';
import styles from './Badge.module.scss';

export default function Badge({ text, margin = false }) {
  return <span className={margin == false ? styles.badge : styles.badgeMargin}>{text}</span>;
}
